import { graphql } from "@/graphql";

// prettier-ignore
export default graphql(`
  query MyRecruitmentUser($recruitmentId: ID!) {
    myRecruitmentUser(recruitmentId: $recruitmentId) {
      id
      role {
        ...UserRoleParts
      }
    }
  }
`);

// prettier-ignore
export const MyRecruitmentUsersQuery = graphql(`
  query MyRecruitmentUsers {
    myRecruitmentUsers {
      id
      recruitment {
        id
      }
      role {
        ...UserRoleParts
      }
    }
  }
`);
